/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IDREGeral } from '../../../shared/services/api/Financeiro/Relatorios';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

async function RDREGeral(Data: IDREGeral, periodo: string){

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const { recebimento, pagamentos, fazendas } = Data;

  const TRecebimento = recebimento.reduce((acc, item) => acc + item.recebimento, 0);
  const TPagamento = pagamentos.reduce((acc, item) => acc + item.pagamento, 0);
  const Tsaldo = TRecebimento - TPagamento;

  const TRecebimentofaz = fazendas.reduce((acc, item) => acc + item.recebimento, 0);
  const TPagamentofaz = fazendas.reduce((acc, item) => acc + item.pagamento, 0);
  const Tsaldofaz = TRecebimentofaz - TPagamentofaz;

  const receb = recebimento.map((rowos) => {
    return [
      {text: rowos.conta, alignment: 'left',   fontSize: 8,  border: [true, false, false, true]},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.recebimento), 
        alignment: 'right',  fontSize: 8,  border: [true, false, false, true]},
    ];
  }); 

  const pgto = pagamentos.map((rowos) => {
    return [
      {text: rowos.conta, alignment: 'left',   fontSize: 8,  border: [true, false, false, true]},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.pagamento), 
        alignment: 'right',  fontSize: 8,  border: [true, false, false, true]},
    ];
  }); 

  const faz = fazendas.map((rowos) => {
    return [
      {text: rowos.descricao, alignment: 'left',   fontSize: 8},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.recebimento), 
        alignment: 'right',  fontSize: 8},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.pagamento), 
        alignment: 'right',  fontSize: 8},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.saldo), 
        alignment: 'right',  fontSize: 8},
    ];
  }); 

  const documentDefinition : any = {
    pageSize: 'A4',  
    pageMargins: [10, 5, 10, 5], 
    //pageOrientation: 'landscape', 
    content: [
      {
        table: {
          margin: [0, 0, 0, 0],  
          widths: [48, 800],  
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },  
              {
                border: [false, false, false, false],
                table: {
                  widths: [500],
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: 
                        process.env.COR_RELATORIOS_TEXTO,  alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                    [ 
                      {text: 'Resultado Geral', margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  
                        border: [false, false, false, false]},
                    ],
                  ]
                }
              }
            ],    
          ]   
        }
      },
      { text: periodo,  alignment: 'left', fillColor: '#dddddd', fontSize: 8},   
      {
        table: {    
          widths: [270, 1, 270],
          body: [
            [    
              {text: '', 
                fillColor: '#dddddd', 
                fontSize: 18, bold: true, 
                alignment: 'left',   
                border: [true, true, false, true],
              },
              {text: '', fillColor: '#dddddd',  border: [false, true, false, true]   },
              {text: 'Saldo: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Tsaldo), 
                alignment: 'right',
                fillColor: '#dddddd', 
                fontSize: 18, bold: true, 
                border: [false, true, true, true],
              },
            ],
            [    
              {text: 'Recebimentos', 
                fillColor: '#dddddd', 
                fontSize: 18, bold: true, 
                alignment: 'left',   
                border: [true, true, true, true],
              },
              {text: '', fillColor: '#5e5e5e',  border: [false, false, false, false]   },
              {text: 'Pagamentos', 
                alignment: 'left',
                fillColor: '#dddddd', 
                fontSize: 18, bold: true, 
                border: [true, true, true, true],
              },
            ],
            [
              {
                margin: [-5, -3, 0, 0],  
                table: {   
                  widths: [200, 61],
                  body: [
                    [
                      {text: 'Conta', fontSize: 10, alignment: 'left', border: [true, false, false, true] },
                      {text: 'Valor',  fontSize: 10, alignment: 'right', border: [true, false, false, true] },
                    ],
                    ...receb,
                  ] 
                }, 
                border: [true, true, true, false],      

              },
              {text: '', fillColor: '#5e5e5e',  border: [false, false, false, false]   },
              {

                margin: [-5, -3, 0, 0],  
                table: {   
                  widths: [200, 61],
                  body: [
                    [
                      {text: 'Conta', fontSize: 10, alignment: 'left', border: [true, false, false, true] },
                      {text: 'Valor',  fontSize: 10, alignment: 'right', border: [true, false, false, true] },
                    ],
                    ...pgto,
                  ] 
                }, 
                border: [true, true, true, false],      
              
              },

            ],
            [
              {text: 'Total: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TRecebimento), 
                alignment: 'right',  fillColor: '#dddddd', border: [true, false, true, true] },
              {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, false] },
              {text: 'Total: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TPagamento), 
                alignment: 'right',  fillColor: '#dddddd', border: [true, false, true, true] },
             
            ],    
            [
              {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, true] },
              {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, true] },
              {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, true] },
             
            ],    
          ]
        }
      },
      {
        margin: [0, 20, 0, 0],  
        table: {
          widths: [200, 60, 60, 60],  
          body: 
          [
            [ 
              {text: 'Fazenda', fontSize: 10, alignment: 'left', },
              {text: 'Recebimento',  fontSize: 10, alignment: 'right' },
              {text: 'Pagamento',  fontSize: 10, alignment: 'right' },
              {text: 'Saldo',  fontSize: 10, alignment: 'right' },
            ], 
            ...faz,
            [
              {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, false] },
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TRecebimentofaz), 
                alignment: 'right', fontSize: 8,  fillColor: '#dddddd', border: [true, false, true, true] },
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TPagamentofaz), 
                alignment: 'right', fontSize: 8,  fillColor: '#dddddd', border: [true, false, true, true] },
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Tsaldofaz), 
                alignment: 'right', fontSize: 8, fillColor: '#dddddd', border: [true, false, true, true] },
            ],   
          ]   
        }
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true
      },
      subheader: {
        fontSize: 15,
        bold: true
      },
      quote: {
        italics: true
      },
      small: {
        fontSize: 8
      }
    }
  };
  pdfMake.createPdf(documentDefinition).open();
}
export default RDREGeral; 


